

















































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import AlertSettings from './alert-settings.vue';
import _ from 'lodash';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';

const cssPrefix = 'alert-container';
@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwButton,
    AlertSettings,
  },
})
export default class AlertSlider extends SwExtendedVue {
  cssPrefix = cssPrefix;
  pageNumber: string = '1';
  notificationList: any = [];
  vulNotification: any = {};
  pinnedList: any = [];
  isEmptyPinned: boolean = false;
  showVulNotification: boolean = false;
  unpinnedList: any = [];
  isEmptyUnpinned: boolean = false;
  notificationPreference: any = [];
  emailSubscription: any = [];
  get overlayStyle(): CSSStyleOptions {
    return {
      width:'100%',
    };
  }
  get getPanelWidth() {
    const widthStyle: any = {
      width: '',
    };
    widthStyle.width = '50vw';
    return widthStyle;
  }
  created() {
    this.getAllAlerts();
  }
  getAllAlerts() {
    Promise.all([
      this.$store.dispatch('MswAlertModule/getAll'),
      this.$store.dispatch('MswAlertModule/getVulNotification'),
    ])
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp[0].msgCode === 'MSWAPP:SUCCESS') {
        this.notificationList = resp[0].content.notificationTypeList;
        this.unpinnedList = _.chain(this.notificationList)
          .filter(obj => obj.isPin === false)
          .groupBy('notificationClassificationText')
          .toPairs()
          .map(item => _.zipObject(['notificationClassificationText', 'notifylist'], item))
          .value();
        this.pinnedList = _.chain(this.notificationList)
          .filter(obj => obj.isPin)
          .groupBy('notificationClassificationText')
          .toPairs()
          .map(item => _.zipObject(['notificationClassificationText', 'notifylist'], item))
          .value();
        this.checkForEmptyList();
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp[0].msgDesc });
      }

      if (resp[1].msgCode === 'MSWAPP:SUCCESS') {
        this.showVulNotification = true;
        this.vulNotification = resp[1].content;
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp[1].msgDesc });
      }
    });
  }
  checkForEmptyList() {
    if (this.pinnedList === undefined || this.pinnedList.length === 0) this.isEmptyPinned = true;
    if (this.unpinnedList === undefined || this.pinnedList.length === 0) this.isEmptyUnpinned = true;
  }
  goToSettingsPage() {
    this.$store.dispatch('MswAlertModule/getUserDetails', this.$store.getters.getUserId)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'Success') {
        this.notificationPreference = resp.content.notificationPref;
        this.getEmailSub();
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }
  getEmailSub() {
    this.$store.dispatch('MswAlertModule/getEmailSubscription')
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.emailSubscription = resp.content.EmailSubscriptionList;
        this.pageNumber = '2';
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }
  backToFirstPage() {
    this.pageNumber = '1';
  }
  goToAlerts() {
    this.$router.push({ path: '/m/feature/alerts' });
  }
  onCloseSlide() {
    this.$emit('closeAlert');
  }
}
